
<section class="w-full h-[89px] bg-[#EDE9E3] flex items-center">
  <div class="w-full flex flex-col gap-3 px-4">
    <div class="flex justify-between gap-1">
      <div
        class="step"
        :class="steps.indexOf(current) > index && 'done' || current == step && 'active'"
        v-for="(step, index) in quoteSteps"
        :key="step"
      />
    </div>
    <div v-if="customSize" class="flex justify-between items-center step-text">
      <span>Custom Size</span> <span>{{ currentStep }}</span> 
    </div>
    <span v-else v-html="currentText" class="step-text"/>
  </div>
</section>
